import { render, staticRenderFns } from "./SectionCategoryProductsGrid.vue?vue&type=template&id=5185a951&scoped=true&"
import script from "./SectionCategoryProductsGrid.vue?vue&type=script&lang=js&"
export * from "./SectionCategoryProductsGrid.vue?vue&type=script&lang=js&"
import style0 from "./SectionCategoryProductsGrid.vue?vue&type=style&index=0&id=5185a951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185a951",
  null
  
)

export default component.exports